//#region src/core/ui/container/data.ts
/** @internal */
const ContainerDataAttrs = { 
/** Present when player controls are visible. */
controlsVisible: "data-controls-visible" };
//#endregion
export { ContainerDataAttrs };
